import React, { useMemo, useState } from 'react';
import { Input, Spin } from 'antd';
import { isEmpty, filter } from 'lodash';

import './SearchStops.scss';
import Icons from '../../icons';
import { useTranslation } from 'react-i18next';
import { stopMatchesQuery } from '../../utils/stopFilter';

const SearchStops = ({ stops, onClickStop }) => {
  const { t } = useTranslation('routes');
  const [searchValue, setSearchValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickStop = (stop) => {
    onClickStop(stop);
    setSearchValue('');
  };

  // OVO-150 — shared matcher: also matches orderRef / partnerOrderRef (the
  // ids operators copy from the orders table — searching them used to find
  // nothing) + the real partner name/code, and no longer treats the input
  // as a regex.
  // OVO-228 — includeName: this is a lookup for ONE specific stop, so it ALSO
  // matches the recipient/pickup NAME the operator sees on the stop (e.g.
  // "Anna Giavazzi"). The inline day-plan FILTER intentionally does NOT (OVO-205
  // precision).
  const searchedStops = useMemo(() => {
    if (!isEmpty(searchValue)) {
      return filter(stops, (o) => stopMatchesQuery(o, searchValue, { includeName: true }));
    } else {
      return [];
    }
  }, [searchValue, stops]);

  const handleOnSearch = (e) => {
    setLoading(true);
    setTimeout(() => {
      setSearchValue(e.target.value);
      setLoading(false);
    }, 100);
  };

  return (
    <div className="SearchStops">
      <div className="SearchBox">
        <Input.Search allowClear placeholder={t('searchStop')} onChange={handleOnSearch} value={searchValue} />
      </div>
      {!isEmpty(searchValue) && searchedStops?.length > 0 && (
        <Spin spinning={loading}>
          <div className="StopsList">
            <div className="Title">{t('stopsFound', { count: searchedStops?.length })}</div>
            {searchedStops.map((stop, index) => {
              const status = stop?.status;
              const driverName = stop?.driverName ?? t('driver');
              return (
                <div
                  key={index + (stop.id || stop.orderIds?.[0] || stop.orderId)}
                  className="StopItem order-popup"
                  onClick={() => handleClickStop(stop)}
                >
                  <div className="header">
                    <div className="left">
                      <div
                        className={`type ${stop.type.toLowerCase()}`}
                        style={{
                          border: `1px solid ${stop.color}`,
                          color: `${stop.color}`,
                        }}
                      >
                        {stop.index}
                      </div>
                      {stop.orderCode}
                    </div>
                    <div className="right">
                      <Icons type="InfoWindowCar" className="info-icon" color={stop.color} />
                      {driverName && <div className="driverInfo">{driverName}</div>}
                    </div>
                  </div>
                  <div className="content-top">
                    <span className={`status orderStatus ${status?.code?.toLowerCase()}`}>{status?.name}</span>
                    <div className="name">{stop.name}</div>
                  </div>
                  <div className="content-address">{stop.address}</div>
                </div>
              );
            })}
          </div>
        </Spin>
      )}
    </div>
  );
};

export default SearchStops;
